define(function() { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
		parse: __webpack_require__(2),
		partials: __webpack_require__(4)
	};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var resolver = __webpack_require__(3);
	
	function parse(templates, bootstrap, deps) {
		var _ = deps.underscore;
		var customTemplates = _.extend({}, templates);
	
		for (var key in customTemplates) {
			if (customTemplates[key] !== '') {
				customTemplates[key] = resolver.resolve(customTemplates[key], bootstrap, deps);
			}
		}
		return customTemplates;
	}
	
	module.exports = parse;
	


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var components = __webpack_require__(4);
	
	module.exports = {
		resolve: function(template, config, deps) {
			if (!template) return;
			return template.replace(/{{([\s\S]+?)}}/g, function(s) {
				var componentsData = components.getData(deps);
				var key = s.slice(2, -2);
				var resolver = componentsData[key];
				if (resolver) {
					// The key is a component
					return resolver(config, deps);
				} else if (deps && deps.l10nFn) {
					// The key is property key || not
					return deps.l10nFn(key) || key;
				}
				// Fallback - will return raw value of s
				return s;
			});
		}
	};
	


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Get URLs and other primary data
	var getUserData = __webpack_require__(5);
	var getMarketplaceData = __webpack_require__(6);
	var getManageData = __webpack_require__(7);
	
	// Get Links
	var getManageLinks = __webpack_require__(8);
	var getMarketplaceLinks = __webpack_require__(11);
	var getUserLinks = __webpack_require__(12);
	
	// Get List Items
	var getManageListItems = __webpack_require__(13);
	var getMarketplaceListItems = __webpack_require__(16);
	var getUserListItems = __webpack_require__(17);
	
	// Get Lists
	var getRenderList = __webpack_require__(18);
	
	// Get Dropdowns
	var getRenderDropdowns = __webpack_require__(34);
	var dropdownClickFunction = __webpack_require__(37);
	
	var UniversalSearchBox = __webpack_require__(38);
	var IconsLink = __webpack_require__(40);
	
	var MyAppsList = __webpack_require__(46);
	
	// Old partials that need to be refactored, but are currently still in use in some early migrations.
	var companyDropdown = __webpack_require__(48); // Deprecated
	
	function getData(deps) {
		var userData = getUserData.getUserData(deps);
		var marketplaceData = getMarketplaceData.getMarketplaceData(deps);
		var manageData = getManageData.getManageData(deps);
		var manageLinks = getManageLinks.renderManageLinks(deps);
		var marketplaceLinks = getMarketplaceLinks.renderMarketplaceLinks(deps);
		var userLinks = getUserLinks.renderUserLinks(deps);
		var manageListItems = getManageListItems.renderManageListItems(deps);
		var marketplaceListItems = getMarketplaceListItems.renderMarketplaceListItems(deps);
		var userListItems = getUserListItems.renderUserListItems(deps);
		var renderList = getRenderList.getRenderList(deps);
		var renderDropdown = getRenderDropdowns.getRenderDropdowns(deps);
	
		return {
	
			// AD MANAGE Components
			// -------------------------------------------------------
			MANAGE_LIST: renderList.renderManageList,
			MANAGE_DROPDOWN: renderDropdown.renderManageDropdown,
	
			ACCOUNT_HREF: manageData.getAccountUrl,
			ACCOUNT_LINK: manageLinks.renderAccountLink,
			ACCOUNT_LI: manageListItems.renderAccountListItem,
	
			CHANNEL_HREF: manageData.getChannelUrl,
			CHANNEL_LINK: manageLinks.renderChannelLink,
			CHANNEL_LI: manageListItems.renderChannelListItem,
	
			CORPORATE_HREF: manageData.getCorporateUrl,
			CORPORATE_LINK: manageLinks.renderCorporateLink,
			CORPORATE_LI: manageListItems.renderCorporateListItem,
	
			DEVELOPER_HREF: manageData.getDeveloperUrl,
			DEVELOPER_LINK: manageLinks.renderDeveloperLink,
			DEVELOPER_LI: manageListItems.renderDeveloperListItem,
	
			RESELLER_HREF: manageData.getResellerUrl,
			RESELLER_LINK: manageLinks.renderResellerLink,
			RESELLER_LI: manageListItems.renderResellerListItem,
	
			SUPERUSER_HREF: manageData.getSuperUserUrl,
			SUPERUSER_LINK: manageLinks.renderSuperuserLink,
			SUPERUSER_LI: manageListItems.renderSuperuserListItem,
	
			// AD MARKETPLACE Components
			// -------------------------------------------------------
			HOME_HREF: marketplaceData.getHomeUrl,
			HOME_LINK: marketplaceLinks.renderHomeLink,
			HOME_LI: marketplaceListItems.renderHomeListItem,
	
			LOGIN_HREF: marketplaceData.getLogInUrl,
			LOGIN_LINK: marketplaceLinks.renderLogInLink,
			LOGIN_LI: marketplaceListItems.renderLogInListItem,
	
			LOGOUT_HREF: marketplaceData.getLogOutUrl,
			LOGOUT_LINK: marketplaceLinks.renderLogOutLink,
			LOGOUT_LI: marketplaceListItems.renderLogOutListItem,
	
			MYAPPS_HREF: marketplaceData.getMyAppsUrl,
			MYAPPS_LINK: marketplaceLinks.renderMyAppsLink,
			MYAPPS_LI: marketplaceListItems.renderMyAppsListItem,
	
			MARKETPLACE_HREF: marketplaceData.getMarketplaceUrl,
	
			SIGNUP_HREF: marketplaceData.getSignUpUrl,
			SIGNUP_LINK: marketplaceLinks.renderSignUpLink,
			SIGNUP_LI: marketplaceListItems.renderSignUpListItem,
	
			CURRENT_LANGUAGE: marketplaceData.getCurrentLanguage,
			CURRENT_LANGUAGE_TAG: marketplaceData.getCurrentLanguageTag,
	
			LANGUAGE_LINKS: renderList.renderLanguageList,
			LANGUAGE_SELECT: renderList.renderLanguageSelect,
			LANGUAGE_DROPDOWN: renderDropdown.renderLanguageDropdown,
	
			COPYRIGHT_YEAR: marketplaceData.getCopyrightYear,
	
			PRIVACY_POLICY_URL: marketplaceData.getPrivacyPolicyUrl,
	
			// Channel Settings Support
			SUPPORT_URL: marketplaceData.getSupportUrl,
	
			SUPPORT_EMAIL: marketplaceData.getSupportEmail,
	
			SUPPORT_PHONE: marketplaceData.getSupportPhone,
	
			SUPPORT_CONTACT_URL: marketplaceData.getSupportContactUrl,
	
			// Channel Settings Legal
			TERMS_URL: marketplaceData.getTermsUrl,
	
			// AD USER Components
			// -------------------------------------------------------
			USER_LIST: renderList.renderUserList,
			USER_DROPDOWN: renderDropdown.renderProfileDropdown,
	
			SUBSCRIPTION_HREF: userData.getSubscriptionUrl,
			SUBSCRIPTION_LINK: userLinks.renderSubscriptionLink,
			SUBSCRIPTION_LI: userListItems.renderSubscriptionListItem,
	
			COMPANY_HREF: userData.getCompanyUrl,
			COMPANY_LINK: userLinks.renderCompanyLink,
			COMPANY_LI: userListItems.renderCompanyListItem,
	
			PROFILE_HREF: userData.getProfileUrl,
			PROFILE_LINK: userLinks.renderProfileLink,
			PROFILE_LI: userListItems.renderProfileListItem,
	
			SETTINGS_HREF: userData.getSettingsUrl,
			SETTINGS_LINK: userLinks.renderSettingsLink,
			SETTINGS_LI: userListItems.renderSettingsListItem,
	
			MOBILE_SWITCH_HREF: userData.getMobileSwitchUrl,
			MOBILE_SWITCH_LINK: userLinks.renderMobileSwitchLink,
			MOBILE_SWITCH_LI: userListItems.renderMobileSwitchListItem,
	
			USER_EMAIL: userData.getUserEmail,
	
			USER_NAME: userData.getUserName,
			USER_FIRSTNAME: userData.getUserFirstName,
			USER_IMG: userData.getUserImg,
			SEARCH_BOX: new UniversalSearchBox().render,
			MYAPPS_DROPDOWN: new MyAppsList().render,
			SEARCH_FORM: renderList.renderSearch,
	
			COMPANY_LIST: renderList.renderCompanyList,
			COMPANY_DROPDOWN: renderDropdown.renderCompanyDropdown,
	
			ICON_HOME: new IconsLink().renderHome,
			ICON_APPWISE: new IconsLink().renderAppWise,
			ICON_APPINSIGHT: new IconsLink().renderAppInsight,
			ICON_MARKETPLACE: new IconsLink().renderMarketplace,
			ICON_USER_IMG: new IconsLink().renderUserImg,
	
			CURRENCY_DROPDOWN: renderDropdown.renderCurrencyDropdown,
	
			JS_DROPDOWN_CLICK: function() {
				return dropdownClickFunction;
			},
	
			// Universal Header React Components
			// intentionally blank strings
			// -------------------------------------------------------
			'MPLOGO-COMPONENT': '',
			'MYAPPS-DROPDOWN-COMPONENT': '',
			'ICON-HOME-COMPONENT': '',
			'ICON-APPWISE-COMPONENT': '',
			'ICON-APPINSIGHT-COMPONENT': '',
			'ICON-MARKETPLACE-COMPONENT': '',
	
			// -------------------------------------------------------
			// DEPRECATED
			// (use only the components above)
			// -------------------------------------------------------
			MANAGE_LINKS: renderList.renderManageLinksOld,
	
			COMPANIES_DROPDOWN: function(config) {
				return companyDropdown.render(config.UserInfo, config.memberships, deps);
			}
		};
	}
	
	module.exports = {
		getData: getData
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	function getUserData(deps) {
		function hasCapability(config, setting, url) {
			if (!config.UserInfo || !config.UserInfo[setting]) return '';
	
			return '/' + url + '/' + config.UserInfo[setting];
		}
		function getSetting(config, setting) {
			if (!config.UserInfo || !config.UserInfo[setting]) return '';
	
			return config.UserInfo[setting];
		}
	
		return {
	
			getSubscriptionUrl: function() {
				return '/subscription';
			},
	
			getProfileUrl: function(config) {
				return hasCapability(config, 'user_id', 'profile');
			},
	
			getCompanyUrl: function(config) {
				return hasCapability(config, 'company_id', 'companies');
			},
	
			getSettingsUrl: function() {
				return '/settings';
			},
	
			getMobileSwitchUrl: function() {
				var fn = deps && deps.switchMobileLinkFunction;
				return 'javascript:' + (fn || ''); // eslint-disable-line no-script-url
			},
	
			getUserEmail: function(config) {
				return getSetting(config, 'email');
			},
	
			getUserName: function(config) {
				return getSetting(config, 'name');
			},
	
			getUserFirstName: function(config) {
				return getSetting(config, 'given_name');
			},
	
			getUserImg: function(config) {
				return config.IMG_BASE + '/profilePics/' + getSetting(config, 'profilePic');
			}
		};
	}
	
	module.exports = {
		getUserData: getUserData
	};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	function getMarketplaceData(deps) {
		var languages = deps.languages;
	
		function getSetting(config, setting) {
			if (!config.CHANNEL_SETTINGS || !config.CHANNEL_SETTINGS[setting]) return '';
	
			return config.CHANNEL_SETTINGS[setting];
		}
	
		return {
	
			getCopyrightYear: function() {
				return '&\#169; ' + (new Date(Date.now()).getFullYear());
			},
	
			getCurrentLanguage: function(config) {
				return languages[config.locale] || '';
			},
	
			getCurrentLanguageTag: function(config) {
				if (!config.locale) { return ''; }
	
				return config.locale;
			},
	
			getHomeUrl: function() {
				return '/home';
			},
	
			getLogInUrl: function() {
				return '/login';
			},
	
	
			getLogOutUrl: function() {
				return '/logout';
			},
	
			getMyAppsUrl: function() {
				return '/myapps';
			},
	
			getPrivacyPolicyUrl: function(config) {
				return getSetting(config, 'privacyPolicyUrl');
			},
	
			getSignUpUrl: function() {
				return '/signup';
			},
	
			getSupportUrl: function(config) {
				return getSetting(config, 'supportUrl');
			},
	
			getSupportEmail: function(config) {
				return getSetting(config, 'supportEmail');
			},
	
			getSupportPhone: function(config) {
				return getSetting(config, 'supportPhone');
			},
	
			getSupportContactUrl: function(config) {
				return getSetting(config, 'supportContactUrl');
			},
	
			getTermsUrl: function(config) {
				return getSetting(config, 'termsUrl');
			}
		};
	}
	
	module.exports = {
		getMarketplaceData: getMarketplaceData
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	function getManageData(deps) {
		function hasUserInfoRoles(config) {
			return config && config.UserInfo && config.UserInfo.roles;
		}
	
		return {
	
			getAccountUrl: function() {
				return '/account/home';
			},
	
			getChannelUrl: function(config) {
				var _ = deps.underscore;
				if (!hasUserInfoRoles(config)) return '';
	
				var ROLES = config.UserInfo.roles;
				var isChannelAdmin = _.contains(ROLES, 'CHANNEL_ADMIN');
				var isChannelProductSupport = _.contains(ROLES, 'CHANNEL_PRODUCT_SUPPORT');
				var isChannelProductSupportOnly = !isChannelAdmin && isChannelProductSupport;
				var CHANNEL = config.CHANNEL_SETTINGS;
				var isBaas = CHANNEL.baas;
				var CHANNEL_PROGRESS_PAGES = 6; // keep in sync with monolith
				var isChannelGuideInProgress = CHANNEL.walkMeEnabled && CHANNEL.guideProgresses && CHANNEL.guideProgresses.CHANNEL < CHANNEL_PROGRESS_PAGES;
				var url = '/channel/marketplace';
	
				if (isChannelProductSupportOnly && !isBaas) {
					url = '/channel/products';
				} else if (isChannelAdmin && isChannelGuideInProgress) {
					url = '/channel/guide';
				}
	
				return url;
			},
	
			getCorporateUrl: function() {
				return '/corporate/home';
			},
	
	
			getInsightUrl: function(app) {
				return app ? app.launchUrl : '';
			},
	
			getDeveloperUrl: function() {
				return '/cms/home';
			},
	
			getResellerUrl: function() {
				return '/reseller';
			},
	
			getSuperUserUrl: function(config) {
				var _ = deps.underscore;
				if (!hasUserInfoRoles(config)) return '';
	
				return _.contains(config.UserInfo.roles, 'SUPERUSER') ? '/superuser/dashboard' : '/superuser/support';
			}
		};
	}
	
	module.exports = {
		getManageData: getManageData
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Link = __webpack_require__(9);
	var getManageData = __webpack_require__(7);
	
	function renderManageLinks(depsArg) {
		var manageData = getManageData.getManageData(depsArg);
		var _ = depsArg.underscore;
		var user,
			roles,
			company,
			channel;
	
		function getCapabilities(config) {
			user = config.UserInfo || {};
			roles = user.roles || [];
			company = config.CompanyInfo || {};
			channel = config.CHANNEL_SETTINGS || {};
		}
	
		return {
	
			renderAccountLink: function render(config, deps) {
				getCapabilities(config);
	
				return (new Link({
					labelRaw: 'Account',
					urlSource: manageData.getAccountUrl(),
					isVisible: !company.onlyAdminsCanBuy || _.contains(roles, 'BILLING_ADMIN'),
					className: 'account-link admin-item', // For MyAppsController.js
					id: 'account' // For MyAppsController.js
				})).render(config, deps);
			},
	
			renderChannelLink: function render(config, deps) {
				getCapabilities(config);
	
				return (new Link({
					labelRaw: 'channel',
					urlSource: manageData.getChannelUrl(config),
					isVisible: _.intersection(roles, ['CHANNEL_ADMIN', 'CHANNEL_SUPPORT', 'CHANNEL_PRODUCT_SUPPORT', 'SALES_SUPPORT']).length
				})).render(config, deps);
			},
	
			renderCorporateLink: function render(config, deps) {
				getCapabilities(config);
	
				return (new Link({
					labelRaw: 'corporate',
					urlSource: manageData.getCorporateUrl(),
					isVisible: _.contains(roles, 'CORPORATE_ADMIN')
				})).render(config, deps);
			},
	
			renderInsightLink: function render(config, deps) {
				getCapabilities(config);
				var myAppsData = config && config.myapps && config.myapps.content || {};
				var insightApp = _.findWhere(myAppsData, { universalNavigatorProductType: 'APPINSIGHT' });
	
				return (new Link({
					labelRaw: 'Insights',
					urlSource: manageData.getInsightUrl(insightApp),
					isVisible: !!insightApp
				})).render(config, deps);
			},
	
	
			renderDeveloperLink: function render(config, deps) {
				getCapabilities(config);
	
				var link = new Link({
					labelRaw: (_.contains(roles, 'CHANNEL_ADMIN') && company.vendor) ? 'BillingAndDistribution' : 'Developer',
					urlSource: manageData.getDeveloperUrl(),
					isVisible: _.contains(channel.capabilities, 'DEVELOPER') && channel.cmsEnabled && company.vendor && _.contains(roles, 'DEVELOPER'),
					id: 'developer' // For MyAppsController.js
				});
	
				return link.render(config, deps);
			},
	
			renderResellerLink: function render(config, deps) {
				getCapabilities(config);
	
				return (new Link({
					labelRaw: 'reseller',
					urlSource: manageData.getResellerUrl(),
					isVisible: _.intersection(roles, ['RESELLER_MANAGER', 'RESELLER', 'REFERRAL']).length
				})).render(config, deps);
			},
	
			renderSuperuserLink: function render(config, deps) {
				getCapabilities(config);
	
				return (new Link({
					labelRaw: 'appdirectadmin',
					urlSource: manageData.getSuperUserUrl(config),
					isVisible: _.intersection(roles, ['SUPERUSER', 'SUPER_SUPPORT']).length,
					className: 'superuser-link'
				})).render(config, deps);
			}
		};
	}
	
	module.exports = {
		renderManageLinks: renderManageLinks
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adLinkTemplate = __webpack_require__(10);
	
	var Link = function(options) {
		this.labelRaw = options.labelRaw;
		this.url = options.urlSource;
		this.isVisible = options.isVisible;
		this.className = options.className;
		this.id = options.id;
		this.clickFunction = options.clickFunction;
		this.value = options.value;
	};
	
	Link.prototype.render = function(config, deps) {
		if (!this.isVisible) return '';
	
		var _ = deps.underscore;
		var l = deps.l10nFn;
		var linkTemplate = _.template(adLinkTemplate);
	
		return linkTemplate({
			label: l(this.labelRaw),
			url: this.url,
			value: this.value,
			className: this.className,
			id: this.id,
			clickFunction: this.clickFunction
		});
	};
	
	module.exports = Link;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
		'<a class="ad-component--link <%= className %>"' +
			'<% if(id) {%> id="<%= id %>"<%}%>' +
			'<% if(value) {%> attr-value="<%= value %>"<%}%>' +
			'<% if(clickFunction) {%> onClick="<%= clickFunction %>"<%}%>' +
			'<% if(url) {%> href="<%= url %>"<%}%>>' +
			'<%= label %>' +
		'</a>';


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Link = __webpack_require__(9);
	var getMarketplaceData = __webpack_require__(6);
	
	function renderMarketplaceLinks(depsArg) {
		var marketplaceData = getMarketplaceData.getMarketplaceData(depsArg);
		var _ = depsArg.underscore;
	
		return {
	
			renderHomeLink: function render(config, deps) {
				return (new Link({
					isVisible: true,
					labelRaw: 'Marketplace',
					urlSource: marketplaceData.getHomeUrl(),
					id: 'shop' // for MyAppsController.js
				})).render(config, deps);
			},
	
			renderLogInLink: function render(config, deps) {
				return (new Link({
					isVisible: true,
					labelRaw: 'sign.in',
					urlSource: marketplaceData.getLogInUrl()
				})).render(config, deps);
			},
	
			renderLogOutLink: function render(config, deps) {
				return (new Link({
					isVisible: true,
					labelRaw: 'logout',
					urlSource: marketplaceData.getLogOutUrl()
				})).render(config, deps);
			},
	
			renderMyAppsLink: function render(config, deps) {
				var channel = config.CHANNEL_SETTINGS || {};
	
				return (new Link({
					isVisible: _.contains(channel.capabilities, 'CUSTOMER_APPLICATION_MANAGEMENT'),
					labelRaw: 'My.Apps',
					urlSource: marketplaceData.getMyAppsUrl(),
					id: 'myapps' // For MyAppsController.js
				})).render(config, deps);
			},
	
			renderSignUpLink: function render(config, deps) {
				var channel = config.CHANNEL_SETTINGS || {};
	
				return (new Link({
					isVisible: !channel.hideSignupLinks,
					labelRaw: 'sign.up',
					urlSource: marketplaceData.getSignUpUrl()
				})).render(config, deps);
			}
		};
	}
	
	module.exports = {
		renderMarketplaceLinks: renderMarketplaceLinks
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Link = __webpack_require__(9);
	var getUserData = __webpack_require__(5);
	
	function renderUserLinks(depsArg) {
		var userData = getUserData.getUserData(depsArg);
		var _ = depsArg.underscore;
		var user,
			roles,
			channel;
	
		function getCapabilities(config) {
			user = config.UserInfo || {};
			roles = user.roles || [];
			channel = config.CHANNEL_SETTINGS || {};
		}
	
		return {
			renderSubscriptionLink: function(config, deps) {
				getCapabilities(config);
	
				return (new Link({
					labelRaw: 'My.Subscription',
					urlSource: userData.getSubscriptionUrl(),
					isVisible: channel.accountEdition && _.contains(roles, 'CHANNEL_ADMIN')
				})).render(config, deps);
			},
	
			renderCompanyLink: function render(config, deps) {
				return (new Link({
					labelRaw: 'My.Company',
					urlSource: userData.getCompanyUrl(config),
					isVisible: config.CHANNEL_SETTINGS.showProfiles
				})).render(config, deps);
			},
	
			renderProfileLink: function render(config, deps) {
				return (new Link({
					labelRaw: 'My.Profile',
					urlSource: userData.getProfileUrl(config),
					isVisible: config.CHANNEL_SETTINGS.showProfiles
				})).render(config, deps);
			},
	
			renderSettingsLink: function render(config, deps) {
				return (new Link({
					labelRaw: 'my.settings',
					urlSource: userData.getSettingsUrl(config),
					isVisible: !config.CHANNEL_SETTINGS.identityProvider
				})).render(config, deps);
			},
	
			renderMobileSwitchLink: function render(config, deps) {
				function getMobileSwitchLabel() {
					return config.isAdMobileWebApp
						? 'Go.to.Desktop.Site'
						: 'Go.to.Mobile.Site';
				}
	
				var displayMobileLink = (
					deps && deps.shouldDisplayGoToMobileLink
				) || function() { return false; };
	
				var link = (new Link({
					labelRaw: getMobileSwitchLabel(),
					isVisible: config.isAdMobileWebApp || displayMobileLink(),
					urlSource: userData.getMobileSwitchUrl(config)
				})).render(config, deps);
	
				return link;
			}
		};
	}
	
	module.exports = {
		renderUserLinks: renderUserLinks
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ListItem = __webpack_require__(14);
	var getManageLinks = __webpack_require__(8);
	
	function renderManageListItems(depsArg) {
		var manageLinks = getManageLinks.renderManageLinks(depsArg);
	
		return {
	
			renderAccountListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: manageLinks.renderAccountLink(config, deps),
					className: 'ad-component_list-item--account'
				})).render(config, deps);
			},
	
			renderInsightListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: manageLinks.renderInsightLink(config, deps),
					className: 'ad-component_list-item--insights'
				})).render(config, deps);
			},
	
			renderChannelListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: manageLinks.renderChannelLink(config, deps),
					className: 'ad-component_list-item--channel'
				})).render(config, deps);
			},
	
			renderCorporateListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: manageLinks.renderCorporateLink(config, deps),
					className: 'ad-component_list-item--corporate'
				})).render(config, deps);
			},
	
			renderDeveloperListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: manageLinks.renderDeveloperLink(config, deps),
					className: 'ad-component_list-item--developer'
				})).render(config, deps);
			},
	
			renderResellerListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: manageLinks.renderResellerLink(config, deps),
					className: 'ad-component_list-item--reseller'
				})).render(config, deps);
			},
	
			renderSuperuserListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: manageLinks.renderSuperuserLink(config, deps),
					className: 'ad-component_list-item--superuser'
				})).render(config, deps);
			}
		};
	}
	
	module.exports = {
		renderManageListItems: renderManageListItems
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adListItemTemplate = __webpack_require__(15);
	
	var ListItem = function(options) {
		this.className = options.className;
		this.linkComponent = options.linkComponent;
	};
	
	ListItem.prototype.render = function(config, deps) {
		if (!this.linkComponent) return '';
	
		var _ = deps.underscore;
	
		var liTemplate = _.template(adListItemTemplate);
	
		return liTemplate({
			className: this.className,
			linkComponent: this.linkComponent
		});
	};
	
	module.exports = ListItem;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '<li class="ad-component_list-item <%= className %>"><%= linkComponent %></li>';


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ListItem = __webpack_require__(14);
	var getMarketplaceLinks = __webpack_require__(11);
	
	function renderMarketplaceListItems(depsArg) {
		var marketplaceLinks = getMarketplaceLinks.renderMarketplaceLinks(depsArg);
	
		return {
	
			renderHomeListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: marketplaceLinks.renderHomeLink(config, deps),
					className: 'ad-component_list-item--home'
				})).render(config, deps);
			},
	
			renderLogInListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: marketplaceLinks.renderLogInLink(config, deps),
					className: 'ad-component_list-item--login'
				})).render(config, deps);
			},
	
			renderLogOutListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: marketplaceLinks.renderLogOutLink(config, deps),
					className: 'ad-component_list-item--logout'
				})).render(config, deps);
			},
	
			renderMyAppsListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: marketplaceLinks.renderMyAppsLink(config, deps),
					className: 'ad-component_list-item--myapps'
				})).render(config, deps);
			},
	
			renderSignUpListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: marketplaceLinks.renderSignUpLink(config, deps),
					className: 'ad-component_list-item--signup'
				})).render(config, deps);
			}
		};
	}
	
	module.exports = {
		renderMarketplaceListItems: renderMarketplaceListItems
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ListItem = __webpack_require__(14);
	var getUserLinks = __webpack_require__(12);
	
	function renderUserListItems(depsArg) {
		var userLinks = getUserLinks.renderUserLinks(depsArg);
	
		return {
	
			renderSubscriptionListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: userLinks.renderSubscriptionLink(config, deps),
					className: 'ad-component_list-item--subscription'
				})).render(config, deps);
			},
	
			renderCompanyListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: userLinks.renderCompanyLink(config, deps),
					className: 'ad-component_list-item--company'
				})).render(config, deps);
			},
	
			renderProfileListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: userLinks.renderProfileLink(config, deps),
					className: 'ad-component_list-item--profile'
				})).render(config, deps);
			},
	
			renderSettingsListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: userLinks.renderSettingsLink(config, deps),
					className: 'ad-component_list-item--settings'
				})).render(config, deps);
			},
	
			renderMobileSwitchListItem: function render(config, deps) {
				return (new ListItem({
					linkComponent: userLinks.renderMobileSwitchLink(config, deps),
					className: 'ad-component_list-item--mobile-switch'
				})).render(config, deps);
			}
		};
	}
	
	module.exports = {
		renderUserListItems: renderUserListItems
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var List = __webpack_require__(19);
	var ListOld = __webpack_require__(21);
	var Select = __webpack_require__(22);
	var getUserListItems = __webpack_require__(17);
	var getManageListItems = __webpack_require__(13);
	var getMarketplaceListItems = __webpack_require__(16);
	var getLanguageListItems = __webpack_require__(24);
	var getCurrencyListItems = __webpack_require__(25);
	var getLanguageSelectOptions = __webpack_require__(26);
	var getCompanyListItems = __webpack_require__(29);
	var adSearchTemplate = __webpack_require__(30);
	var languageFunctionTemplate = __webpack_require__(31);
	var companyFunctionTemplate = __webpack_require__(32);
	var currencyFunctionTemplate = __webpack_require__(33);
	
	function getRenderList(depsArgs) {
		var userListItems = getUserListItems.renderUserListItems(depsArgs);
		var manageListItems = getManageListItems.renderManageListItems(depsArgs);
		var marketplaceListItems = getMarketplaceListItems.renderMarketplaceListItems(depsArgs);
		var languageListItems = getLanguageListItems.renderLanguageListItems(depsArgs);
		var languageSelectItems = getLanguageSelectOptions.renderLanguageSelectOptions(depsArgs);
		var companyListItems = getCompanyListItems.renderCompanyListItems(depsArgs);
		var currencyListItems = getCurrencyListItems.renderCurrencyListItems(depsArgs);
	
		function getLocaleTags(config) {
			if (!config.CHANNEL_SETTINGS || !config.CHANNEL_SETTINGS.localeTags) {
				return '';
			}
			var locales = config.CHANNEL_SETTINGS.localeTags;
			if (locales.length === 1) return '';
	
			return locales;
		}
	
		return {
	
			renderUserList: function render(config, deps) {
				return (new List({
					list: [
						userListItems.renderSubscriptionListItem(config, deps),
						userListItems.renderProfileListItem(config, deps),
						userListItems.renderCompanyListItem(config, deps),
						userListItems.renderSettingsListItem(config, deps),
						marketplaceListItems.renderLogOutListItem(config, deps)
					].join(''),
					className: 'ad-component_list--user-list'
				})).render(config, deps);
			},
	
			renderManageList: function render(config, deps) {
				return (new List({
					list: [
						manageListItems.renderAccountListItem(config, deps),
						manageListItems.renderInsightListItem(config, deps),
						manageListItems.renderChannelListItem(config, deps),
						manageListItems.renderCorporateListItem(config, deps),
						manageListItems.renderDeveloperListItem(config, deps),
						manageListItems.renderResellerListItem(config, deps),
						manageListItems.renderSuperuserListItem(config, deps)
					].join(''),
					className: 'ad-component_list--manage-list manage-links'
				})).render(config, deps);
			},
	
			renderManageLinksOld: function render(config, deps) {
				return (new ListOld({
					list: [
						manageListItems.renderAccountListItem(config, deps),
						manageListItems.renderChannelListItem(config, deps),
						manageListItems.renderCorporateListItem(config, deps),
						manageListItems.renderDeveloperListItem(config, deps),
						manageListItems.renderResellerListItem(config, deps),
						manageListItems.renderSuperuserListItem(config, deps)
					].join(''),
					className: 'ad-component_list--manage-list manage-links'
				})).render(config, deps);
			},
	
			renderLanguageList: function render(config, deps) {
				if (!getLocaleTags(config)) return '';
	
				return languageFunctionTemplate + (new List({
					list: languageListItems.getLanguageListItems(config, deps),
					className: 'ad-component_list--language-list language-links'
				})).render(config, deps);
			},
	
			renderLanguageSelect: function render(config, deps) {
				if (!getLocaleTags(config)) return '';
	
				return languageFunctionTemplate + (new Select({
					list: languageSelectItems.getLanguageSelectOptions(config, deps),
					className: 'ad-component_list--language-select language-select',
					changeFunction: 'changeLanguage(value)'
				})).render(config, deps);
			},
	
			renderSearch: function render() {
				return adSearchTemplate;
			},
	
			renderCompanyList: function render(config, deps) {
				var user = config.UserInfo;
				var memberships = config.memberships;
				var result = '';
				var companyFunctionTpl = !config.jQueryDisabled ? companyFunctionTemplate : '';
	
				if (user && memberships && memberships.length > 1) {
					return companyFunctionTpl + (new List({
						list: companyListItems.getCompanyListItems(config, deps),
						className: 'ad-component_list--company-list company-links'
					})).render(config, deps);
				}
				return result;
			},
	
			renderCurrencyList: function render(config, deps) {
				return currencyFunctionTemplate + (new List({
					list: currencyListItems.getCurrencyListItems(config, deps),
					className: 'currency-links'
				})).render(config, deps);
			}
		};
	}
	
	module.exports = {
		getRenderList: getRenderList
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adListTemplate = __webpack_require__(20);
	
	var List = function(options) {
		this.className = options.className;
		this.list = options.list;
	};
	
	List.prototype.render = function(config, deps) {
		// If list is empty return nothing
		if (!this.list) return '';
	
		// If list contains only 1 element return that element (not wrapped in a 'ul')
		if (this.list.match(/<\/li>/g).length === 1) return this.list;
	
		var _ = deps.underscore;
		var listTemplate = _.template(adListTemplate);
	
		return listTemplate({
			className: this.className,
			list: this.list
		});
	};
	
	module.exports = List;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '<ul class="ad-component_list <%= className %>"><%= list %></ul>';


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adListTemplate = __webpack_require__(20);
	
	var ListOld = function(options) {
		this.className = options.className;
		this.list = options.list;
	};
	
	ListOld.prototype.render = function(config, deps) {
		// If list is empty return nothing
		if (!this.list) return '';
	
		var _ = deps.underscore;
		var listTemplate = _.template(adListTemplate);
	
		return listTemplate({
			className: this.className,
			list: this.list
		});
	};
	
	module.exports = ListOld;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adSelectTemplate = __webpack_require__(23);
	
	var Select = function(options) {
		this.className = options.className;
		this.list = options.list;
		this.changeFunction = options.changeFunction;
	};
	
	Select.prototype.render = function(config, deps) {
		if (!this.list) return '';
		var _ = deps.underscore;
		var selectTemplate = _.template(adSelectTemplate);
		return selectTemplate({
			className: this.className,
			list: this.list,
			changeFunction: this.changeFunction
		});
	};
	
	module.exports = Select;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '<select class="ad-component_select <%= className %>"' +
			'<% if(changeFunction) {%> onchange="<%= changeFunction %>"<%}%>>' +
	'<%= list %></select>';


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Link = __webpack_require__(9);
	var ListItem = __webpack_require__(14);
	function renderLanguageListItems() {
		return {
	
			getLanguageListItems: function render(config, deps) {
				var _ = deps.underscore;
				var languages = deps.languages;
				var locales = config.CHANNEL_SETTINGS.localeTags;
	
				return _.reduce(locales, function(result, locale) {
					var languageLink = new Link({
						labelRaw: languages[locale],
						isVisible: true,
						value: locale,
						clickFunction: "changeLanguage('" + locale + "')"
					}).render(config, deps);
					result += new ListItem({
						linkComponent: languageLink,
						className: config.locale === locale ? 'selected' : ''
					}).render(config, deps);
	
					return result;
				}, '');
			}
		};
	}
	
	module.exports = {
		renderLanguageListItems: renderLanguageListItems
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Creating the channel supported currencies list
	 */
	'use strict';
	
	var Link = __webpack_require__(9);
	var ListItem = __webpack_require__(14);
	function renderCurrencyListItems() {
		return {
			getCurrencyListItems: function render(config, deps) {
				var _ = deps.underscore;
				var currencies = config.CHANNEL_SETTINGS.currencies; // Currencies supported by the channel.
	
				return _.reduce(currencies, function(result, currency) {
					var currencyLink = new Link({
						labelRaw: currency,
						isVisible: true,
						value: currency,
						clickFunction: "changeCurrency('" + currency + "')"
					}).render(config, deps);
					result += new ListItem({
						linkComponent: currencyLink,
						className: config.defaultCurrency === currency ? 'selected' : ''
					}).render(config, deps);
	
					return result;
				}, '');
			}
		};
	}
	
	module.exports = {
		renderCurrencyListItems: renderCurrencyListItems
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var SelectItem = __webpack_require__(27);
	function renderLanguageSelectOptions() {
		return {
	
			getLanguageSelectOptions: function render(config, deps) {
				var _ = deps.underscore;
				var languages = deps.languages;
				var locales = config.CHANNEL_SETTINGS.localeTags;
	
				return _.reduce(locales, function(result, locale) {
					result += new SelectItem({
						labelRaw: languages[locale],
						value: locale,
						selected: config.locale === locale
					}).render(config, deps);
	
					return result;
				}, '');
			}
		};
	}
	
	module.exports = {
		renderLanguageSelectOptions: renderLanguageSelectOptions
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adSelectItemTemplate = __webpack_require__(28);
	
	var SelectItem = function(options) {
		this.labelRaw = options.labelRaw;
		this.className = options.className;
		this.id = options.id;
		this.selected = options.selected;
		this.value = options.value;
	};
	
	SelectItem.prototype.render = function(config, deps) {
		var _ = deps.underscore;
		var l = deps.l10nFn;
	
		var optionTemplate = _.template(adSelectItemTemplate);
	
		return optionTemplate({
			label: l(this.labelRaw),
			className: this.className,
			id: this.id,
			selected: this.selected,
			value: this.value
		});
	};
	
	module.exports = SelectItem;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '<option <%= selected ? \'selected="selected"\' : \'\'%> class="ad-component_select--option <%= className %>"<% if(id) {%> id="<%= id %>"<%}%> value="<%= value %>"><%= label %></option>';


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Link = __webpack_require__(9);
	var ListItem = __webpack_require__(14);
	function renderCompanyListItems() {
		return {
	
			getCompanyListItems: function render(config, deps) {
				var _ = deps.underscore;
				var user = config.UserInfo;
				var memberships = config.memberships;
	
				return _.reduce(memberships, function(result, membership) {
					var clickFunction = !config.jQueryDisabled ? "changeCompanyContext('" + user.user_id + "', '" + membership.company.uuid + "')" : undefined;
					var companyLink = new Link({
						labelRaw: membership.company.name,
						isVisible: true,
						value: membership.company.uuid,
						clickFunction: clickFunction
					}).render(config, deps);
					result += new ListItem({
						linkComponent: companyLink,
						className: membership.company.uuid === user.company_id ? 'selected' : ''
					}).render(config, deps);
	
					return result;
				}, '');
			}
		};
	}
	
	module.exports = {
		renderCompanyListItems: renderCompanyListItems
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
		'<form class="ad-component_search" name="searchForm" id="idc" method="get" action="/listing">' +
			'<div class="ad-component_search--input">' +
				'<label>Search: </label>' +
				'<input type="text" maxlength="200" value="" name="q" placeholder="">' +
			'</div>' +
			'<button class="ad-component_search--button" type="submit" aria-label="Search">' +
				'<i class="adb-icon__search"></i>' +
			'</button>' +
		'</form>';
	
	
	
	


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = [
		'<script type="text/javascript">',
		'  function changeLanguage(lang) {',
		'    document.dispatchEvent(new CustomEvent(\'universalnav:call\', { detail: { widget: \'Header\', method: \'clearStorage\' } }));',
		'    document.cookie = \'locale-language=\' + lang + \'; path=/\';',
		'    window.location.reload();',
		'  }',
		'</script>'
	].join('\n');
	


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = [
		'<script type="text/javascript">',
		'  function changeCompanyContext(userId, companyId) {',
		'    document.dispatchEvent(new CustomEvent(\'universalnav:call\', { detail: { widget: \'Header\', method: \'clearStorage\' } }));',
		'    $.ajax({',
		'      url: \'/api/account/v2/users/\' + userId + \'/memberships/\' + companyId + \'/current\',',
		'      type: \'put\'',
		'    }).then(function () {',
		'      window.location = \'/home\';',
		'    });',
		'  }',
		'</script>'
	].join('\n');


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/*
	 ************ changeCurrency ************
	 * @param currently selected currency
	 * changeCurrency function will be triggered when currency is selected from dropdown.
	 * There are different flows for logged-in and logged-out versions.
	 *
	 ************* Logged In version *************
	 * Ajax call is made to update the logged-in users default currency to currently selected currency.
	 * After Ajax success, event is triggered to update the listing, home or profile pages data.
	 *
	 ************* Logged out version *************
	 * Event is triggered to update the listing, home or profile pages data.
	 *
	 ************* currency:change Event *************
	 * currency:change Event will be listened on Home, Listing and Profile pages to update the products data according to the currently selected currency.
	 * Whenever currency is changed, the prices will be hidden or shown for the products on home and listing page if they are supported in that currency and country.
	 * Product profile page needs to be updated according to the currency if it is supported in that currency and country.
	 * So to update the home, listing and Profile pages this event needs to be listened on these pages.
	*/
	'use strict';
	
	module.exports = [
		'<script>',
		'function changeCurrency(currency) {',
		' if(window.UserInfo){',
		'   $.ajax({',
		'     url: "/api/account/v2/users/" + window.UserInfo.user_id,',
		'     type: "PATCH",',
		'     contentType: "application/json",',
		'     data: JSON.stringify({currency: currency})',
		'   }).then(function () {',
		'   document.dispatchEvent(new CustomEvent(\'currency:change\', { detail : {currency: currency}}));',
		'   })',
		' } else{',
		' document.dispatchEvent(new CustomEvent(\'currency:change\', { detail : {currency: currency}}));',
		' }',
		' document.dispatchEvent(new CustomEvent(\'universalnav:call\', { detail: { widget: \'Header\', method: \'clearStorage\' } }));',
		' $(".currency-dropdown>a").text(currency)',
		' $(".currency-dropdown .ad-component_list-item.selected").removeClass("selected")',
		' $(event.currentTarget).parent().addClass("selected")',
		'}',
		'</script>'
	].join('\n');
	
	


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Get Lists
	var getRenderList = __webpack_require__(18);
	var Dropdown = __webpack_require__(35);
	var getUserData = __webpack_require__(5);
	
	function getRenderDropdowns(depsArg) {
		var renderList = getRenderList.getRenderList(depsArg);
		var userData = getUserData.getUserData();
	
		return {
			renderManageDropdown: function render(config, deps) {
				return (new Dropdown({
					listContainer: renderList.renderManageList(config, deps),
					className: 'manage-dropdown',
					linkClassName: 'manage-link',
					label: 'Manage'
				})).render(config, deps);
			},
	
			renderLanguageDropdown: function render(config, deps) {
				return (new Dropdown({
					listContainer: renderList.renderLanguageList(config, deps),
					className: 'language-dropdown',
					label: deps.languages[config.locale] || ''
				})).render(config, deps);
			},
	
			renderProfileDropdown: function render(config, deps) {
				return (new Dropdown({
					listContainer: renderList.renderUserList(config, deps),
					className: 'user-dropdown',
					label: userData.getUserName(config)
				})).render(config, deps);
			},
	
			renderCompanyDropdown: function render(config, deps) {
				var user = config.UserInfo;
				var memberships = config.memberships;
				var _ = deps.underscore;
				var result = '';
				var currentMembership;
				var currentCompany;
	
				if (user && memberships && memberships.length > 0) {
					currentMembership = _.find(memberships, function(membership) {
						return membership.company.uuid === user.company_id;
					});
	
					try {
						currentCompany = currentMembership.company.name;
					} catch (e) {
						currentCompany = null;
					}
	
					return (new Dropdown({
						listContainer: renderList.renderCompanyList(config, deps),
						className: 'company-dropdown',
						label: currentCompany
					})).render(config, deps);
				}
	
				return result;
			},
	
			renderCurrencyDropdown: function render(config, deps) {
				return (new Dropdown({
					listContainer: renderList.renderCurrencyList(config, deps),
					className: 'currency-dropdown',
					label: config.defaultCurrency
				})).render(config, deps);
			}
		};
	}
	
	module.exports = {
		getRenderDropdowns: getRenderDropdowns
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adDropdownTemplate = __webpack_require__(36);
	
	var Dropdown = function(options) {
		this.className = options.className;
		this.linkClassName = options.linkClassName || '';
		this.listContainer = options.listContainer;
		this.label = options.label;
	};
	
	Dropdown.prototype.render = function(config, deps) {
		// If the dropdown is empty return nothing.
		if (!this.listContainer) return '';
	
		// If dropdown contains only one element, return that element, and not the dropdown.
		if (this.listContainer.match(/<\/li>/g).length === 1) return this.listContainer;
	
		var _ = deps.underscore;
		var l = deps.l10nFn;
		var dropdownTemplate = _.template(adDropdownTemplate);
	
		return dropdownTemplate({
			className: this.className,
			linkClassName: this.linkClassName,
			label: l(this.label),
			listContainer: this.listContainer
		});
	};
	
	module.exports = Dropdown;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
		'<li class="ad-component_list--item ad-component_dropdown <%= className %>">' +
			'<a class="ad-component--link ad-component_dropdown--trigger <%= linkClassName %>" href="javascript:;"><%= label %></a>' +
			'<%= listContainer %>' +
		'</li>';


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	function adComponentDropdownToggle() {
		$(document).on('click', '.ad-component_dropdown .ad-component_dropdown--trigger', function() {
			if ($(this).hasClass('ad-component_dropdown--is-active')) {
				$(this).removeClass('ad-component_dropdown--is-active');
			} else {
				$('.ad-component_dropdown .ad-component_dropdown--is-active').removeClass('ad-component_dropdown--is-active');
				$(this).addClass('ad-component_dropdown--is-active');
			}
		});
		$(document).on('click', function(e) {
			if (!$(e.target).is('.ad-component_dropdown .ad-component_dropdown--trigger')) {
				$('.ad-component_dropdown .ad-component_dropdown--is-active').removeClass('ad-component_dropdown--is-active');
			}
		});
	}
	
	module.exports = [
		'<style>',
		'.ad-component_dropdown > .ad-component_list {',
		'display: none;',
		'}',
		'.ad-component_dropdown .ad-component_dropdown--is-active ~ .ad-component_list {',
		'display: block;',
		'}',
		'</style>',
		'<script>',
		'(',
		adComponentDropdownToggle.toString(),
		')();',
		'</script>'
	].join('\n');
	


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var template = __webpack_require__(39);
	
	function UniversalSearchBox() {
	
	}
	
	UniversalSearchBox.prototype.render = function(config, deps) {
		var _ = deps.underscore;
		return _.template(template)();
	};
	
	module.exports = UniversalSearchBox;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '<div data-adb-component="appdirectUniversalSearch" class="appdirectUniversalSearch"></div>';


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var templateHome = __webpack_require__(41);
	var templateWise = __webpack_require__(42);
	var templateInsight = __webpack_require__(43);
	var templateMarketplace = __webpack_require__(44);
	var templateUserImgs = __webpack_require__(45);
	
	// AppWise App IDs
	var appWise = 42937,
		appWiseDev = 189629,
		appInsight = 10030,
		appInsightDev = 189746;
	
	function IconItems() {}
	
	function getAppLink(id, defaultId, myapps) {
		return myapps.find(function(app) {
			return id === app.applicationId || defaultId === app.applicationId;
		}).launchUrl;
	}
	
	IconItems.prototype.renderHome = function(config, deps) {
		var _ = deps.underscore;
		var l = deps.l10nFn;
		var marketUrl = config.marketUrl;
		var app = config.myapps && config.myapps.content && config.myapps.content.find(function(item) {
			return item.applicationId === appWise || item.applicationId === appWiseDev;
		});
		if (app) {
			var target = encodeURIComponent(marketUrl + '/appwise/feeds/recents');
			var href = getAppLink(appWise, appWiseDev, config.myapps.content) + '&targetUrl=' + target;
			var options = Object.assign(
				{},
				app,
				{
					tooltipLabel: l('Home'),
					href: href || ''
				}
			);
			return _.template(templateHome)(options);
		}
		return '';
	};
	
	IconItems.prototype.renderAppWise = function(config, deps) {
		var _ = deps.underscore;
		var l = deps.l10nFn;
		var marketUrl = config.marketUrl;
		var app = config.myapps && config.myapps.content && config.myapps.content.find(function(item) {
			return item.applicationId === appWise || item.applicationId === appWiseDev;
		});
		if (app) {
			var target = encodeURIComponent(marketUrl + '/appwise/messages');
			var href = getAppLink(appWise, appWiseDev, config.myapps.content) + '&targetUrl=' + target;
			var options = Object.assign(
				{},
				app,
				{
					tooltipLabel: l('Teams'),
					href: href || ''
				}
			);
			return _.template(templateWise)(options);
		}
		return '';
	};
	
	IconItems.prototype.renderAppInsight = function(config, deps) {
		var _ = deps.underscore;
		var l = deps.l10nFn;
	
		var app = config.myapps && config.myapps.content && config.myapps.content.find(function(item) {
			return item.applicationId === appInsight || item.applicationId === appInsightDev;
		});
		if (app) {
			var href = getAppLink(appInsight, appInsightDev, config.myapps.content);
			var options = Object.assign(
				{},
				app,
				{
					tooltipLabel: l('Insights'),
					href: href || ''
				}
			);
			return _.template(templateInsight)(options);
		}
		return '';
	};
	
	IconItems.prototype.renderUserImg = function(config, deps) {
		var _ = deps.underscore;
		var userImg = config.UserInfo && config.UserInfo.profilePic;
		if (userImg) {
			var options = Object.assign(
				{},
				{ userImg: config.IMG_BASE + '/profilePics/' + userImg }
			);
			return _.template(templateUserImgs)(options);
		}
		return '';
	};
	
	IconItems.prototype.renderMarketplace = function(config, deps) {
		var _ = deps.underscore;
		var l = deps.l10nFn;
	
		var options = {
			tooltipLabel: l('Marketplace'),
			href: config.CHANNEL_SETTINGS.channelCanonicalBaseUrl + '/home' || ''
		};
		return _.template(templateMarketplace)(options);
	};
	
	
	module.exports = IconItems;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
	'<li class="ad-universalnav-icons" adu-tooltip="<%= tooltipLabel %>" adu-tooltip-position="bottom">' +
			'<a home-link="true" class="ad-icon-link" href="<%= href %>">' +
				'<i class="ad-icon-home"></i>' +
			'</a>' +
	'</li>';


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
	'<li class="ad-universalnav-icons"  adu-tooltip="<%= tooltipLabel %>" adu-tooltip-position="bottom">' +
			'<a wise-link="true" class="ad-icon-link" href="<%= href %>">' +
				'<i class="ad-icon-group"></i>' +
				'<span class="ad-team-notification"></span>' +
			'</a>' +
	'</li>';


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
	'<li class="ad-universalnav-icons" adu-tooltip="<%= tooltipLabel %>" adu-tooltip-position="bottom">' +
			'<a insight-link="true" class="ad-icon-link" href="<%= href %>">' +
				'<i class="ad-icon-bar-graph"></i>' +
			'</a>' +
	'</li>';


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
	'<li class="ad-universalnav-icons" adu-tooltip="<%= tooltipLabel %>" adu-tooltip-position="bottom">' +
			'<a class="ad-icon-link" marketplace-link="true" id="shop" href="<%= href %>">' +
				'<i class="ad-icon-cart"></i>' +
			'</a>' +
	'</li>';


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = '<img class="ad-img-profile-pic" src="<%= userImg %>" />';


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var template = __webpack_require__(47);
	
	function MyAppsList() {
	
	}
	
	MyAppsList.prototype.render = function(config, deps) {
		var _ = deps.underscore;
		var l = deps.l10nFn;
		var options = Object.assign(
			{ myapps: { content: [] } },
			config,
			{
				listAllApps: l('List.all.apps'),
				href: config.CHANNEL_SETTINGS.channelCanonicalBaseUrl + '/myapps'
			}
		);
		return _.template(template)(options);
	};
	
	module.exports = MyAppsList;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports =
	'<ul class="ad-stack-apps <% if(myapps.content.filter(function (app) { return app.launchUrl }).length > 9) { %>ad-stack-apps--with-button<% } %>">' +
		'<% myapps.content.filter(function(app) { return app.launchUrl }).some(function(app, i) {%>' +
			'<li class="ad-stack-apps--item" href="<%= app.launchUrl %>">' +
				'<div class="ad-stack-apps--item-img-container">' +
					'<% if(app.imageUrl) { %>' +
						'<img class="ad-stack-apps--item-img" src="<%= app.imageUrl %>" />' +
					'<% } else { %>' +
						'<i class="ad-icon-star"></i>' +
					'<% } %>' +
				'</div>' +
				'<div class="ad-stack-apps--item-text"><%= app.name %></div>' +
			'</li>' +
			'<% return i === 8; %>' +
		'<% }) %>' +
			'<li class="ad-stack-apps--item-button">' +
				'<a target="_blank" href="<%= href %>"><%= listAllApps %></a>' +
			'</li>' +
	'</ul>';
	


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var fnTemplate = __webpack_require__(32);
	var template = __webpack_require__(49);
	
	function render(user, memberships, deps) {
		var _ = deps.underscore;
		var result = '';
		var currentMembership;
		var currentCompany;
		var companies;
	
		if (user && memberships && memberships.length > 0) {
			currentMembership = _.find(memberships, function(membership) {
				return membership.company.uuid === user.company_id;
			});
	
			try {
				currentCompany = currentMembership.company.name;
			} catch (e) {
				currentCompany = null;
			}
	
			companies = memberships.map(function(membership) {
				return {
					label: membership.company.name,
					companyId: membership.company.uuid
				};
			});
	
			if (currentCompany && companies.length > 1) {
				result = (fnTemplate + _.template(template)({
					userId: user.user_id,
					currentCompany: currentCompany,
					companies: companies
				}));
			}
		}
	
		return result;
	}
	
	module.exports = {
		render: render
	};
	


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = [
		'<div class="companies-dropdown">',
		'<a class="adb-context_menu--trigger"><%-currentCompany%></a>',
		'<ul class="adb-context_menu--menu">',
		'  <% _.each(companies, function(company) { %>',
		'  <li><a onClick="changeCompanyContext(\'<%-userId%>\', \'<%-company.companyId%>\')"><%= company.label %></a></li>',
		'<% });%>',
		'</ul>',
		'</div>'
	].join('\n');
	


/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// ad-theme-customizer-client.js